import {sectionConfig as config} from "~/config/_pages/about/main"

import HeroUI from "~/components/ui/hero";
import ChatbotBanner from "~/assets/about/hero.svg"

export default function AboutSection() {
  return (
    <HeroUI.Container wide>
      <HeroUI.Body>
        <HeroUI.Heading title={config.title} suptitle={config.suptitle}  />
        <HeroUI.Paragraph>
          {config.caption}
        </HeroUI.Paragraph>
        <HeroUI.Paragraph>
          {config.caption2}
        </HeroUI.Paragraph>
      </HeroUI.Body>
      <HeroUI.Banner size="lg" url={ChatbotBanner.src} alt="asd"/>
    </HeroUI.Container>
  )
}
